/* eslint-disable no-useless-escape */
import React, { useState } from "react";
import { useHistory, withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { pathOr } from "ramda";
import { Button } from "antd";

import { LoginSagaAction, checkUserExist } from "../../sagas/saga-actions";
import { setPopup } from "../../actions/popupAction";
import CustomButton from "../../components/customButton";
import UserService from "../../service/UserService";
import CustomNotification from "../notification";
import CustomInput from "../customInput";
import { emailRegex, usernameRegex } from "../../constants/constants";
import LoginLeftSection from "../loginLeftSection";
import "../login/styles.scss";

const ForgetPassword = (props) => {
  const userservice = new UserService();

  const history = useHistory();

  const [state, setState] = useState({
    email: "",
    gotEmail: false,
    loading: false,
    error: "",
    isSubmit: false,
    resend: false,
    initialValuesLogin: {
      username: "",
    },
  });

  const { customPopupMessage, messageType, message } = props.popupReducer;

  const credentialSchema = Yup.object().shape({
    username: Yup.string().required("Username or Email is required")
      .min(3, "Username or Email must be at least 3 characters")
      .max(60, "Username or Email must be less than 60 characters")
      .test("test-username","Please use correct format for Username or Email",
        (value) => {
          const validEmail = emailRegex.test(value);
          const validUsername = usernameRegex.test(value);
          if (value && !validEmail && !validUsername) {
            return false;
          }
          return true;
        }
      ),
  });

  const onSubmit = async (values, e) => {
    e.preventDefault();

    if (values.username) {
      try {
        setState((st) => ({
          ...st,
          loading: true,
        }));

        const result = await userservice.forgetPassword(values.username);

        setState((st) => ({
          ...st,
          gotEmail: true,
          loading: false,
          email: result.email,
        }));

        props.setPopup({
          customPopupMessage: true,
          message: "Reset password link has been sent to the given email",
          messageType: "success",
        });
      } catch (err) {
        props.setPopup({
          customPopupMessage: true,
          message: pathOr(
            "Something went wrong",
            ["response", "data", "message"],
            err
          ),
          messageType: "error",
        });

        setState((st) => ({
          ...st,
          loading: false,
        }));
      }
    }
  };

  const handleGoBack = () => {
    history.push("/");
  };

  return (
    <div
      data-testid="forgot-password-page-wrapper"
      className="login-page-wrapper"
    >
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}
      <main className="login-page-main" id="forgot-password-page-main">
        <LoginLeftSection />

        {state.gotEmail ? (
          <section className="form-wrapper">
            <h2 className="form-heading">Forgot Password?</h2>
            <p className="form-caption top-gap">
              If the email is valid, you will receive a password reset link. If
              it doesn’t appear within a few minutes, check your spam folder.
            </p>

            <div className="login-form">
              <section className="custom-input-group name-field">
                <Button htmlType="submit" type="primary" onClick={handleGoBack}>
                  Return to Sign In
                </Button>
              </section>
            </div>
          </section>
        ) : (
          <section className="form-wrapper">
            <h2 className="form-heading">Forgot Password?</h2>
            <p className="form-caption">
              Please enter your username or email address
            </p>

            <Formik
              enableReinitialize
              initialValues={state.initialValuesLogin}
              validationSchema={credentialSchema}
              validateOnMount
              isInitialValid={!!state.isInitialValid}
            >
              {({ isValid, values }) => {
                return (
                  <Form
                    id="forgot-password-form"
                    className="login-form"
                    onSubmit={(e) => onSubmit(values, e)}
                  >
                    <section className="custom-input-group name-field">
                      <label className="input-label">
                        Username or Email address
                      </label>
                      <CustomInput
                        className={"custom-form-input"}
                        placeholder="Enter username..."
                        name="username"
                        maxLength={60}
                      />
                    </section>

                    <section className="otp-buttons">
                      <CustomButton
                        htmlType="submit"
                        type="primary"
                        className={!isValid ? "disable-button" : ""}
                        disabled={!isValid}
                        title={state.loading ? "Please wait..!!" : "Submit"}
                      />
                      <CustomButton
                        type="primary"
                        className="cancel-button ml-8"
                        onClick={handleGoBack}
                        title="Go Back"
                      />
                    </section>
                  </Form>
                );
              }}
            </Formik>
          </section>
        )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    checkUserExist: (data) => dispatch(checkUserExist(data)),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ForgetPassword)
);
